// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mo-clickable-image[data-v-1e9fa1b5] {
  display: inline-flex;
  min-width: 100px;
  cursor: pointer;
}
.mo-clickable-image[data-v-1e9fa1b5]:hover {
  border-radius: 0.3rem;
  box-shadow: 0 0 0 3px #5990de;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
